export type DateParser = (value: unknown) => unknown;

// Fallback neutre : aucune dépendance à dayjs (ou autre) dans model-core.
// Chaque projet consommateur configure son propre parseur au bootstrap.
let dateParser: DateParser = (value) => value;

export function configureModelCore(options: { dateParser?: DateParser }) {
	if (options.dateParser) dateParser = options.dateParser;
}

export function getDateParser(): DateParser {
	return dateParser;
}
